<div class="panel panel-default">
  <div class="panel-heading flex flex--space-between">
    <h4 class="margin-top-0 margin-bottom-0 flex">
      <i *ngIf="currencySymbol !== 'CHF'" class="icon margin-right-8">money_notes_GBP</i>
      <small *ngIf="currencySymbol === 'CHF'" class="chf-logo margin-right-8">CHF</small>
      {{ appCopy.panelHeader['excessPaymentTitle'+selectedLanguage] }}
    </h4>
  </div>
  <div class="panel-body" *ngIf="!adminBookingDetailsLoaded">
    <div class="loader-container">
      <div class="loader">
        <svg class="circular" viewBox="25 25 50 50">
          <circle class="path" cx="50" cy="50" r="20" />
        </svg>
      </div>
    </div>
  </div>
  <div class="panel-body" *ngIf="adminBookingDetailsLoaded">
    <p *ngIf="excessBaggagePayment === null || productType !== 1">{{ appCopy.panelHeader['noExcessPaymentTakenText'+selectedLanguage] }}</p>
    <div *ngIf="excessBaggagePayment !== null && productType === 1">
      <app-booking-details-excess-display
        [appCopy]="appCopy"
        [selectedLanguage]= "selectedLanguage"
        [currencySymbol]="currencySymbol"
        [excessBaggagePayment]="excessBaggagePayment"
        [receiptImg]="receiptImg">
      </app-booking-details-excess-display>
    </div>
    <a href="javascript:void(0);" *ngIf="excessBaggagePayment !== null && productType === 1 && excessBaggagePayment.paymentStatus !== 2" (click)="redirectToSettings($event, 'excess-payment')">{{ appCopy.panelHeader['takeExcessPaymentText'+selectedLanguage] }}</a>
  </div>
</div>
